import { Button as AntdButton, Input } from 'antd'
import { ArrowBendDownRight } from 'phosphor-react'
import React, { useContext, useEffect, useState } from 'react'
import { useDropzone } from 'react-dropzone'
import { Controller, useForm } from 'react-hook-form'
import toast from 'react-hot-toast'
import { useTranslation } from 'react-i18next'
import { BsCheck2Square, BsX } from 'react-icons/bs'
import { FiUpload } from 'react-icons/fi'
import { useQuery } from 'react-query'
import { useSelector } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'
import HelmetComponent from '../../Component/Helmet'
import j2bdLogo from '../../assets/images/j2bd.svg'
import holloLogo from '../../assets/images/loghollo.png'
import mailBox from '../../assets/mailbox.svg'
import AuthService from '../../services/AuthService'
import { FeathersContext } from '../../services/feathers'
import { checkFeatureFlag } from '../../utils/featureFlag'
import LayoutOnboardingPages from '../TalentPlatform/components/LayoutOnboardingPages/LayoutOnboardingPages'
import * as s from './NewApply.styles'

const Auth = new AuthService()

// eslint-disable-next-line react/prop-types
function BasicDropZone(props) {
  const { t } = useTranslation(['login', 'common', 'talent', 'talentArea'], {
    useSuspense: false,
  })

  const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
    accept: ['.pdf', '.doc', '.docx'],
    maxFiles: 1,
    multiple: false,
    maxSize: 1024 * 1024 * 5,
    onDropRejected: (data) => {
      // Todo: trad error with data[0]?.errors.code
      if (data?.length && data[0]?.errors?.length) {
        toast.error(data[0]?.errors[0].message)
      }
    },
  })

  const removeFile = (file) => {
    acceptedFiles.splice(file, 1)
    props.setFile(null)
  }

  const files = acceptedFiles.map((file) => (
    <li key={file.path} style={{ display: 'flex', width: '100%' }}>
      <span style={{ flex: 1 }}>
        {file.path} - {file.size} bytes
      </span>
      <BsX
        size={28}
        style={{ cursor: 'pointer', marginRight: 4 }}
        onClick={() => removeFile(file)}
      />
      <BsCheck2Square size={24} color="#20bf6b" />
    </li>
  ))
  useEffect(() => {
    if (acceptedFiles.length) {
      props.setFile(acceptedFiles[0])
    }
  }, [acceptedFiles, props])

  return (
    <section>
      {!files.length && (
        <div className="dropzone" {...getRootProps({ className: 'dropzone' })}>
          <input {...getInputProps()} />
          <p>
            <FiUpload size={28} color="var(--primary)" />
            <span>{t('common:dragAndDropFile')}</span>
          </p>
        </div>
      )}
      {!!files.length && (
        <aside>
          <ul>{files}</ul>
        </aside>
      )}
    </section>
  )
}

/**
 * check if token exists
 * if exists we fill the form and we apply for him
 *
 */

const NewApply = () => {
  const params = useParams()
  const history = useHistory()
  const feathers = useContext(FeathersContext)
  const { t } = useTranslation(['login', 'common', 'talent', 'talentArea'], {
    useSuspense: false,
  })

  const [file, setFile] = useState(null)
  const [applicationSent, setApplicationSent] = useState(false)
  const [isSendingApplication, setIsSendingApplication] = useState(false)
  const [showConfetti, setShowConfetti] = useState(false)

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm()
  const talent = useSelector((state) => state.talent)

  const { data: company } = useQuery({
    enabled: Boolean(params?.companyId),
    queryKey: ['company', params.companyId],
    queryFn: async () =>
      feathers.service('lambda-talent').find({
        query: {
          type: 'getCompany',
          companyId: params.companyId,
        },
      }),
  })

  const handleTalentExistApply = async () => {
    setIsSendingApplication(true)

    try {
      // We can loop first in talent candidateIds and try to find if already exist
      await Auth.signup(params.companyId, {
        firstname: talent.firstname,
        lastname: talent.lastname,
        email: talent.email,
      })

      setTimeout(() => {
        history.push('/app/applications')
      }, 200)
    } catch (error) {
      console.error(error)
    } finally {
      setIsSendingApplication(false)
    }
  }

  const onSubmit = async ({ firstname, lastname, email }) => {
    if (!params.companyId || !company) {
      toast.error(t('An error occured.'))
      return
    }
    if (!file) {
      toast.error(
        t(
          'talentArea:requiredResume',
          'It seems that you forgot to upload your CV, this document is mandatory.',
        ),
      )
      return
    }
    try {
      setIsSendingApplication(true)
      const candidate = await Auth.signup(
        params.companyId,
        {
          firstname,
          lastname,
          email,
        },
        true,
        checkFeatureFlag,
      )

      // Manage file upload
      const formData = new FormData()

      formData.append('uri', file)
      formData.append('name', file?.name)
      formData.append('type', 'resume')
      formData.append('candidateId', candidate._id)

      await Auth.fetch('/lambda-candidate-file', {
        method: 'POST',
        body: formData,
      })

      setApplicationSent(true)
      // setShowConfetti(true)
    } catch (e) {
      console.error(e)
    } finally {
      setIsSendingApplication(false)
    }
  }

  useEffect(() => {
    // This is the only way to know if talent clicked on url to complete its profile
    if (params.companyId && company && talent?.isVerified) {
      handleTalentExistApply()
    }
  }, [params, company, talent])

  if (applicationSent) {
    return (
      <s.NewApply>
        <HelmetComponent
          faviconUrl={checkFeatureFlag ? j2bdLogo : holloLogo}
          name={checkFeatureFlag ? 'J2BD Partners' : 'Hollo'}
        />
        <img src={mailBox} height={180} alt="application-sent" />
        <p
          style={{
            maxWidth: '500px',
            padding: '25px',
            fontSize: '23px',
            lineHeight: '1.75',
            textAlign: 'center',
            paddingBottom: '20px',
            paddingTop: '20px',
          }}
        >
          Pour finaliser votre candidature, <br />
          <div>
            <strong
              style={{
                backgroundColor: '#6A63F6',
                borderRadius: '5px',
                padding: '5px',
                color: 'white',
              }}
            >
              {' '}
              confirmez votre adresse email !{' '}
            </strong>
          </div>
          <ArrowBendDownRight size={32} />
        </p>
      </s.NewApply>
    )
  }
  return (
    <s.NewApply>
      <HelmetComponent
        faviconUrl={checkFeatureFlag ? j2bdLogo : holloLogo}
        name={checkFeatureFlag ? 'J2BD Partners' : 'Hollo'}
      />
      <header>
        <img
          src={checkFeatureFlag ? j2bdLogo : holloLogo}
          height={40}
          alt=""
          className="logo"
        />
        <h1>{t('talent:createTalentArea')} </h1>
      </header>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div style={{ display: 'flex', gap: 10 }}>
          <Controller
            name="firstname"
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <Input {...field} placeholder={t('common:firstname')} />
            )}
          />
          {errors.firstname && (
            <span className="error-field">
              {t('login:inputs.fieldRequired.error')}
            </span>
          )}
          <Controller
            name="lastname"
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <Input {...field} required placeholder={t('common:lastname')} />
            )}
          />
          {errors.lastname && (
            <span className="error-field">
              {t('login:inputs.fieldRequired.error')}
            </span>
          )}
        </div>

        <Controller
          name="email"
          control={control}
          rules={{ required: true }}
          render={({ field }) => (
            <Input {...field} placeholder={t('common:email')} />
          )}
        />
        {errors.email && (
          <span className="error-field">
            {t('login:inputs.fieldRequired.error')}
          </span>
        )}
        <BasicDropZone setFile={setFile} />
        <footer>
          <p>
            En continuant vous acceptez les politiques de confidentialité de{' '}
            <a
              href={
                checkFeatureFlag
                  ? 'https://www.job2bedone-partners.com/mentions-legales'
                  : 'https://hollo.io/privacy-policy'
              }
              target="_blank"
              rel="noreferrer"
            >
              {checkFeatureFlag ? 'J2BD' : 'Hollo'}
            </a>
            {!checkFeatureFlag ? (
              <>
                {' '}
                ainsi que les{' '}
                <a
                  href={company?.policyUrl || 'https://company.com/policy'}
                  target="_blank"
                  rel="noreferrer"
                >
                  notres
                </a>
              </>
            ) : undefined}
            .
          </p>
          <AntdButton
            style={{ fontSize: '18px', width: '100%' }}
            className="basic-btn"
            type="submit"
            htmlType="submit"
            loading={isSendingApplication}
          >
            {t('talentArea:confirm', 'Je confirme')}
          </AntdButton>

          <AntdButton
            style={{ fontSize: '14px', width: '100%', marginTop: '20px' }}
            type="link"
            onClick={() => history.push('/login')}
          >
            Vous avez déjà un compte ? Connectez-vous →
          </AntdButton>
        </footer>
      </form>
    </s.NewApply>
  )
}

const Wrapper = () => (
  <LayoutOnboardingPages type="new-apply">
    <NewApply />
  </LayoutOnboardingPages>
)

export default Wrapper
